var _rect, _rect2, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBatteryPercent(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6.66602,
    y: 4.16602,
    width: 6.66667,
    height: 13.3333,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8.33301,
    y: 2.5,
    width: 3.33333,
    height: 1.66667,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1663 5.415C14.1663 4.49453 13.4202 3.74935 12.4997 3.74935H11.8515V2.18685C11.8515 1.89935 11.6441 1.66602 11.3886 1.66602L8.61079 1.66602C8.35523 1.66602 8.14783 1.89935 8.14783 2.18685V3.74935L7.49967 3.74935C6.5792 3.74935 5.83301 4.49445 5.83301 5.41492C5.83301 8.20878 5.83301 13.8135 5.83301 16.6712C5.83301 17.5917 6.5792 18.3327 7.49967 18.3327H12.4997C13.4202 18.3327 14.1663 17.5916 14.1663 16.6711C14.1663 13.8149 14.1663 8.20925 14.1663 5.415ZM9.07375 2.70768L10.9256 2.70768V3.74935L9.07375 3.74935V2.70768ZM13.2404 16.4577C13.2404 16.9179 12.8673 17.291 12.4071 17.291H7.59227C7.13204 17.291 6.75894 16.9179 6.75894 16.4577L6.75894 5.62435C6.75894 5.16411 7.13203 4.79102 7.59227 4.79102L12.4071 4.79102C12.8673 4.79102 13.2404 5.16411 13.2404 5.62435L13.2404 16.4577Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0833 9.16602H7.91667C7.68655 9.16602 7.5 9.35256 7.5 9.58268V16.2493C7.5 16.4795 7.68655 16.666 7.91667 16.666H12.0833C12.3135 16.666 12.5 16.4795 12.5 16.2493V9.58268C12.5 9.35256 12.3135 9.16602 12.0833 9.16602Z",
    fill: "#61D215"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBatteryPercent);
export default __webpack_public_path__ + "static/media/batteryPercent.3b6896bfd9c50b6a48392efb43e2313d.svg";
export { ForwardRef as ReactComponent };